module.exports = __webpack_public_path__ + "static/media/view4.d18f3605.jpg";